module.exports = __webpack_public_path__ + "img/Grimassen.dc426fde.jpg";